import LogicaAPI from "./logicaapi";

class Canvas extends LogicaAPI {
  async getCanvas(idKey) {
    const params = {
      with_objects: false,
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
    };
    return this.get(`/api/v1/canvases/${idKey}`, {params});
  }
}
export default Canvas;
